import { QrAssetsUnparsed } from '../../assets/models/qrAssetsUnparsed';
import { QrGateway } from '../model/qrGateway';

export const payloadToQrGateway = ({ qr }: QrAssetsUnparsed): QrGateway => {
  return {
    qr,
  };
};
